/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { HierarchiesControllerGetAncestorsQueryResponse, HierarchiesControllerGetAncestorsPathParams, HierarchiesControllerGetAncestorsQueryParams, HierarchiesControllerGetAncestors401, HierarchiesControllerGetAncestors403 } from "../../models/hierarchiesController/HierarchiesControllerGetAncestors";

function getHierarchiesControllerGetAncestorsUrl(scopeId: HierarchiesControllerGetAncestorsPathParams["scopeId"]) {
  const res = { method: 'GET', url: `/api/v1/hierarchies/${scopeId}/ancestors` as const }  
  return res
}

/**
 * @description Retrieve all parent scopes up to the root. Supports filtering by scope type(s) using comma-separated values (e.g., scopeType=FILE,FOLDER)
 * @summary Get ancestor scopes
 * {@link /api/v1/hierarchies/:scopeId/ancestors}
 */
export async function hierarchiesControllerGetAncestors(scopeId: HierarchiesControllerGetAncestorsPathParams["scopeId"], params?: HierarchiesControllerGetAncestorsQueryParams, config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const res = await request<HierarchiesControllerGetAncestorsQueryResponse, ResponseErrorConfig<HierarchiesControllerGetAncestors401 | HierarchiesControllerGetAncestors403>, unknown>({ method : "GET", url : getHierarchiesControllerGetAncestorsUrl(scopeId).url.toString(), params, ... requestConfig })  
  return res.data
}